import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {reduxForm,Field,getFormValues } from 'redux-form';
import {  Row,  FormGroup,Label } from 'reactstrap';
import {  toggleTermsAndCondition } from '../../../actions/payment';

var checked = true
function TermsAndConitionContainer(props) {

        const mrch_tnc_details = props.mrch_tnc_details
        
        const changeStatus = (e) => {
            const status =  e.target.type === "checkbox" ? e.target.checked : e.target.value;
            checked = status
            props.toggleTermsAndCondition(status);        
        }

        return (
            <>
            { mrch_tnc_details && mrch_tnc_details.mrchTNCFlag == "Y" && 
                <FormGroup className="mb-3 auto-height ml-md-3">
                    <Label className="custom-check"><i>{mrch_tnc_details.mrchTNCDesc}</i>
                        <Field name="accept"
                         onChange={changeStatus}
                         checked={checked}
                          component="input" type='checkbox' />
                        <span className="checkmark" style={{"top":"4px"}}></span>
                    </Label>
                </FormGroup>
        }
         </>
      );
    
}

const TermsContent = reduxForm({
    form: 'termsForm',
})(TermsAndConitionContainer)


const mapStateToProps = state => {
    const formValues = getFormValues("termsForm")(state) || {};
    const { mrch_tnc_details } = state.fdData;
    return { mrch_tnc_details, formValues}
}


export default withTranslation("translations")(connect(mapStateToProps, { toggleTermsAndCondition })(TermsContent));
//export default TermsAndConditionTrans
// export default connect(mapStateToProps, { switchTermsAndCondition })(TermsAndConditionTrans);